// by lxm
import axios from 'axios';
import { MessageBox } from 'element-ui';
import router from '../router/index';

// 创建实例时设置配置的默认值
let baseUrl = '/common';

if (process.env.NODE_ENV === 'production') {
  baseUrl = IPConfig.proUrl;
} else {
  //dev 开发环境
}
/**
 * 自定义实例默认值
 */
var instance = axios.create({
  baseURL: baseUrl, // 公	共接口url（如果有多个的公共接口的话，需要处理）
  // timeout: 3000, // 请求超时
});
// /api/getUserById

// 请求拦截器, 进行一个全局loading  加载，这种情况下所有的接口请求前 都会加载一个loading

/**
 * 添加请求拦截器 ，意思就是发起请求接口之前做什么事，一般都会发起加载一个loading
 * */

//  如果不想每个接口都加载loading ，就注释掉请求前拦截器,在http这个类中处理

instance.interceptors.request.use(
  config => {
    if(config.url === '/api/Login/GetValidateImg' 
       || config.url === '/api/Login/Login'
       || config.url === '/api/Login/SendSms'
       || config.url === '/api/Login/Register'){
      config.headers.common['Token'] = '';
    }else{
      // 获取token，配置请求头
      // const TOKEN = localStorage.getItem('Token')
      // 演示的token（注意配置请求头，需要后端做cros跨域处理，我这里自己前端配的跨域）
      const TOKEN = localStorage.getItem('token');
      if(TOKEN){
        // 配置请求头 token
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        config.headers.common['Token'] = TOKEN;
     }
    }
   
    return config;
  },
  error => {
    // 对请求错误做些什么，处理这个错误

    // 可以直接处理或者展示出去,toast show()
    console.warn(error);

    return Promise.reject(error);
  }
);

/**
 * 添加响应拦截器，意思就是发起接口请求之后做什么事，此时只有两种情况，
 * 要么成功，要么失败，但是不管成功，还是失败，我们都需要关闭请求之前的
 * 发起的loading，那既然要处理loading，就把loading做成全局的了，
 * 这里自定义一个处理加载loding 和关闭loading的方法，而且这个loading
 * 要不要加载，会根据外部传入的布尔值来决定，默认是false:不展示
 * */

instance.interceptors.response.use(
  function(response) {
    if(response.data){
      if(response.data.ok === 400){
        MessageBox.alert(response.data.msg);
      }
    }
    return response;
  },
  function(error) {
    if(error.response){
      if(error.response.data && (error.response.data.status === 401)){
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }else if(error.response.data && error.response.data.msg){
        MessageBox.alert(error.response.data.msg);
      }
    }
    return Promise.reject(error);
  }
);

/**
 * 使用es6中的类，进行简单封装
 */

class http {
  // 使用async ... await
  static async get(url, params) {
    return await instance.get(url, {params}) 
  }
  static async post(url, params) {
    return await instance.post(url, params);
  }
  static async delete(url, params) {
    return await instance.delete(url, params);
  }
}


export default http;